import axios from "axios";
import 'url-search-params-polyfill'

import { BASE_URL, LOGIN_URL } from './common';

export function getDeviceList() {
  var url = BASE_URL + 'device?pageSize=10000';

  return axios.get(url);
}

export function registerDevice(
  product,
  version,
  authMode,
  authWay,
  direction,
  imageLogEnable,
  ipAddr,
  nm,
  openDelay,
  ports
) {

  var params = {
    product,
    version,
    authMode,
    authWay,
    direction,
    imageLogEnable,
    ipAddr,
    nm,
    openDelay,
    ports
  }

  var paramStr = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  
  var url = BASE_URL + 'device?' + paramStr;

  return axios.post(url, params);
}


export function deleteDevice(deviceId
) {
  var url = BASE_URL + 'device/' + deviceId;

  return axios.delete(url);
}
